var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNavigateBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-arrow-back-android-mono"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.966 10.7999H6.93L12.381 5.34887C12.4939 5.23777 12.5837 5.10542 12.6452 4.95944C12.7068 4.81346 12.7388 4.65675 12.7394 4.49834C12.74 4.33994 12.7093 4.18297 12.649 4.03649C12.5887 3.89002 12.5 3.75694 12.3879 3.64493C12.2759 3.53292 12.1428 3.44419 11.9964 3.38387C11.8499 3.32355 11.6929 3.29282 11.5345 3.29347C11.3761 3.29411 11.2194 3.32611 11.0734 3.38763C10.9275 3.44914 10.7951 3.53895 10.684 3.65187L3.184 11.1519C3.181 11.1539 3.18 11.1579 3.177 11.1609C3.01249 11.3288 2.9009 11.5413 2.8561 11.772C2.8113 12.0028 2.83526 12.2416 2.925 12.4589C2.985 12.6019 3.07 12.7289 3.177 12.8389L3.184 12.8489L10.684 20.3489C10.919 20.5829 11.226 20.6989 11.532 20.6989C11.7693 20.6989 12.0012 20.6285 12.1985 20.4967C12.3958 20.3649 12.5496 20.1776 12.6405 19.9584C12.7313 19.7392 12.7552 19.498 12.709 19.2653C12.6628 19.0326 12.5487 18.8187 12.381 18.6509L6.931 13.1999H20.967C21.2853 13.1999 21.5905 13.0734 21.8155 12.8484C22.0406 12.6234 22.167 12.3181 22.167 11.9999C22.167 11.6816 22.0406 11.3764 21.8155 11.1513C21.5905 10.9263 21.2853 10.7999 20.967 10.7999",
    fill: "#1B1C1E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavigateBack);
export default __webpack_public_path__ + "static/media/icon_navigate_back.7ac34defa981da0692a027a9c39066c2.svg";
export { ForwardRef as ReactComponent };